import type { ReactElement } from 'react'

import { Tag } from '../Tag/Tag'
import styles from './codeLabel.module.scss'

export type CodeLabelProps = {
  /** The MRPeasy code the configuration stores (`SNS5289`, `C00045`, `AG00004`). */
  code: string
  /** The mirror's title; null when the mirror has none or does not know the code. */
  title: string | null
  /** False for an orphan: the code is stored in `app` and the mirror no longer has it. */
  known: boolean
}

/**
 * A code of the mirror's master data as every configuration screen names it:
 * the code, then the mirror's title.
 *
 * ⚠️ An orphan is shown, never hidden: the code and a «desconocido» tag. The
 * mirror is reloaded and can drop what a row of `app` names, and a row nobody
 * can see is a row nobody fixes.
 */
export const CodeLabel = ({ code, title, known }: CodeLabelProps): ReactElement => (
  <span className={styles['code-label']}>
    <span className={styles['code-label__code']}>{code}</span>
    {known
      ? (title !== null && title !== '' ? <span className={styles['code-label__title']}>{title}</span> : null)
      : <Tag tone="warn" label="desconocido" />}
  </span>
)
